import React, { useEffect, useState } from 'react'
import './MainLayout.scss'

import { Route, Routes, Outlet } from 'react-router-dom'

import ActionBar from './ActionBar/ActionBar'
import UsecaseCreate from 'Components/UsecaseCreate/UsecaseCreate'
import UsecaseList from '../UsecaseList/UsecaseList'
import TacticalView from 'Components/TacticalView/TacticalView'

function MainLayout() {
    return (
        <div className="Main" data-test-id="main-layout">
            <ActionBar />
            <div className="MainLayout" data-test-id="main-layout-container">
                <Routes>
                    <Route exact path="/" element={<UsecaseList />} />
                    <Route path="create" element={<UsecaseCreate />} />
                    <Route path="tactical" element={<TacticalView />} />
                </Routes>
                <Outlet />
            </div>
        </div>
    )
}

export default MainLayout
